<template>
  <v-container>
    <template>
      <v-btn class="input-text-size"
       style="max-width: 200px; margin-top: -96px; margin-left: 35pc" text color="blue darken-1"
       @click="clearBidderListBtn">Clear List</v-btn>
      <CRUDList ref="crudList" :canAdd="true" :canEdit="true" :canCancel="false"
        :canSave="false" :showSelect="false" :canDeleteInDialog="true"
        :enableFixedHeaders="true" :displayTopPagination="false" :headers="headers"
        :baseCrudKey="baseCrudKey" :dialogHeaderName="dialogHeaderName"
        :defaultSortBy="defaultSortBy" dialogDynamicWidth="60vw"
        tableWrapperDynamicClassname='elevation-3 ma-3 pt-0 pa-1 taxroll-table-wrapper'
        tableDynamicClassname='taxroll-custom-table' tableDynamicHeight="370"
        @deleteItem="deleteFromDiaglog"
        @crudDialogClose="handleDialogClose"
        @loadCRUDList="handleLoadList" :loadingData="gridLoading.flag"
        @onSingleClicked="handleSingleOrArrowClick"
        @onDoubleClicked="handleDoubleClick"
        @onArrowUpOrDown="handleSingleOrArrowClick"
        :loadingText="gridLoading.text">
        <template v-slot:[`editedItem`]="{ }">
          <BidderRegistrationDialog :baseCrudKey="baseCrudKey" @loadCRUDList="handleLoadList"
           @handleLogActivity="handleLogActivity" @upsertItem="upsertTransaction"
           @handleLogAndRecalculateBalance="handleLogAndRecalculateBalance"/>
          </template>
          <template v-slot:[`additionalActionsAfterSave`]="{}">
          <v-btn
            class="input-text-size"
            text
            color="blue darken-1"
            @click="upsertTransaction(false)"
          >
            Save
          </v-btn>
          <v-btn
            class="input-text-size"
            text
            color="blue darken-1"
            @click="closeDialog"
          >
            Cancel
          </v-btn>
        </template>
      </CRUDList>
    </template>
  </v-container>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import {
  amountFormat,
  amountToNumber,
  defaultGridLoading, manageGridLoading, zipDeFormat,
  zipFormat,
} from '../../../../../util/shared/vue-global';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import { bidderRegistrationHeader } from '../../deliquentUtils/deliquent.utils';
import BidderRegistrationDialog from './BidderRegistrationDialog.vue';
import { generateQueryString } from '../../../../common/base/report/report-util';
import { clients } from '../../../../../util/clients';

const { backendRest } = clients.direct;

export default {
  name: 'BidderRegistration',
  components: {
    CRUDList,
    BidderRegistrationDialog,
  },
  data() {
    return {
      baseCrudKey: 'BidderRegistration',
      dialogHeaderName: 'Bidder Registration',
      headers: bidderRegistrationHeader,
      gridLoading: defaultGridLoading(),
      bidderActivityCrudKey: 'bidderActivityCrudKey',
      isItFirstCallOrNot: false,
    };
  },
  computed: {
    ...mapGetters('base/crud', ['items', 'item', 'criteria']),
    ...mapState({
      isVisibleBidderRegistration: (state) => state.base.crud.isVisible.BidderRegistration,
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    defaultSortBy() {
      return [
        {
          column: 'regNumber',
          direction: 'asc',
        },
      ];
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setItems', 'setHighlightedId']),
    ...mapMutations('base/crud', ['setCriteria']),
    ...mapActions('tax/juneResale', [
      'bidderRegistration',
      'upsertBidderRegistration',
      'bidderRegistrationLogUpdate',
      'deleteBidderRegistration',
      'updateBidderRegistrationLogAndRecalculateBalance',
      'clearBidderList',
    ]),
    ...mapActions(['custumColrFlashMsg', 'reAuth']),
    handleLoadList(id = '') {
      this.selectedRowData = {};
      manageGridLoading(this, true, 'Searching...');
      const { baseCrudKey } = this;
      const criteria = {
        ...this.criteriaState,
      };
      this.bidderRegistration({
        criteria, baseCrudKey, postProcessTrans: this.postProcessForBidderRegistration,
      }).then((items) => {
        if (id) {
          const item = items.find((i) => i._id === id) || {};
          this.setItems([this.bidderActivityCrudKey, item.logHistory || []]);
          this.setItem([this.baseCrudKey, item]);
          this.setHighlightedId([this.baseCrudKey, item._id]);
        } else {
          this.setDefaultSelectedItems();
        }
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    getBidderTotals(items = []) {
      if (!items.length) {
        return {
          totalDeposits: 0, totalWithdrawals: 0, winningBidsTotal: 0, amountDueToBidder: 0,
        };
      }
      const totalDeposits = items.reduce((acc, item) => acc + (item.type === 'deposit' ? amountToNumber(item.amount || 0) : 0), 0);
      const totalWithdrawals = items.reduce((acc, item) => acc + (item.type === 'withdrawal' ? amountToNumber(item.amount || 0) : 0), 0);
      const winningBidsTotal = items.reduce((acc, item) => acc + (item.type === 'purchase' ? amountToNumber(item.amount || 0) : 0), 0);
      const amountDueToBidder = totalDeposits - (totalWithdrawals - winningBidsTotal);
      return {
        totalDeposits, totalWithdrawals, winningBidsTotal, amountDueToBidder,
      };
    },
    postProcessForBidderRegistration(items) {
      for (let i = 0; i < items.length; i += 1) {
        const element = items[i];
        element.zipCode = zipFormat(element.zipCode);
        const {
          totalDeposits, totalWithdrawals, winningBidsTotal, amountDueToBidder,
        } = this.getBidderTotals(element.logHistory || []);
        element.totalDeposits = amountFormat(totalDeposits) || 0;
        element.totalWithdrawals = amountFormat(totalWithdrawals) || 0;
        element.winningBidsTotal = amountFormat(winningBidsTotal) || 0;
        element.amountDueToBidder = amountFormat(amountDueToBidder) || 0;
      }
      return items;
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.setHighlightedId([this.baseCrudKey, '']);
      });
    },
    closeDialog() {
      this.setItem([this.baseCrudKey, {}]);
      this.setIsVisible([this.baseCrudKey, false]);
    },
    async upsertTransaction(printReportFlag = false) {
      const item = this.item(this.baseCrudKey);
      // if the item is not empty, then upsert the item
      if (Object.values(item).length) {
        const updatedItem = { ...item };
        delete updatedItem.totalDeposits;
        delete updatedItem.winningBidsTotal;
        delete updatedItem.totalWithdrawals;
        delete updatedItem.amountDueToBidder;
        delete updatedItem.logHistory;
        updatedItem.zipCode = zipDeFormat(updatedItem.zipCode);
        const result = await this.upsertBidderRegistration(
          { item: updatedItem },
        );
        if ((result || {}).statusCode === 200) {
          this.handleLoadList();
          // resetting dialog and item
          this.closeDialog();

          if (printReportFlag) {
            const { jwt } = await this.reAuth();
            if (!result._id) {
              this.custumColrFlashMsg({ msg: 'Having some issue' });
              return;
            }

            const params = [
              `token=${jwt}`,
              `recordId=${result._id}`,
            ];
            if (this.devSetting && this.devSetting.isTestEnvironment) {
              params.push('isTestCafe=1');
            }
            const queryString = generateQueryString(params);
            const url = `${backendRest.defaults.baseURL}/juneResale/bidder-registration${queryString}`;
            window.open(url, '_blank');
          }
        }
      }
    },
    deleteFromDiaglog(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deleteBidderRegistration({ item, baseCrudKey });
      }
    },
    async handleLogActivity(item) {
      const result = await this.bidderRegistrationLogUpdate({ item });
      if ((result || {}).statusCode === 200) this.handleLoadList(item._id);
    },
    async handleLogAndRecalculateBalance(item) {
      const result = await this.updateBidderRegistrationLogAndRecalculateBalance({ item });
      if ((result || {}).statusCode === 200) this.handleLoadList(item.mainId);
    },
    handleSingleOrArrowClick(item) {
      const items = item.logHistory || [];
      this.setItems([this.bidderActivityCrudKey, items]);
    },
    handleDoubleClick(item) {
      const items = item.logHistory || [];
      this.setItems([this.bidderActivityCrudKey, items]);
    },
    handleDialogClose() {
      // restting
      this.setItems([this.bidderActivityCrudKey, []]);
    },
    async clearBidderListBtn() {
      if (window.confirm('This will remove all bidder information from the list, are you sure?')) {
        await this.clearBidderList();
        this.handleLoadList();
      }
    },
  },
};
</script>
